import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MaterialTable from "material-table";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { KeyboardDatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  onSnapshot,
} from "firebase/firestore";

import { devicePhaseCode, deviceModeCode, serviceType } from "../../constants/constants";

import { db, getCheckSession, logout } from "../../apis/auth";
import DeviceAddressService from "../../apis/device-address";
import DeviceDataService from "../../apis/device-data"
// import {GetDailyReport} from "./ReportManager" 
import "../../styles/reports.scss";
import { exportMaterialTableToExcel, exportMaterialTableToPDF, format2Decimals, getDateString, getDateStringHHMMSS } from "../../utilities/utility";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import { GetEventReportQuery } from "../../query/event-report.query";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { NotificationManager } from "react-notifications";
import { getAllSLCDevices } from "../../query/device.query";
import PoleDataService from "../../apis/pole-data";

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

const SLCInventory = (props) => {

  const classes = useStyles();
  const history = useHistory();

  const [isAPILoading, setIsAPILoading] = useState(false);
  const [filterObj, setFilterObj] = useState({
    zone: 0,
    ward: 0,
    ccms: 0,
    filterType: 0,
    startDate: new Date(),
    endDate: new Date(),
  });

  const [filterTypeList, setFilterTypeList] = useState([
    {
      label: "UID",
      value: 0,
    },
    {
      label: "Switch No",
      value: 1,
    }
  ]);
  const [zoneFilterList, setZoneFilterList] = useState([]);
  const [wardFilterList, setWardFilterList] = useState([]);
  const [ccmsFilterList, setCcmsFilterList] = useState([]);

  //   const [dashboardReportData, setDashboardReportData] = useState([]);
  const [dashboardReportRawData, setDashboardReportRawData] = useState([]); //TODO: can be removed
  const [opReportData, setOpReportData] = useState([]);

  useEffect(async () => {
    console.log("========== Report : OnInit() ==========");
    var sessionStatus = await getCheckSession();
    if (sessionStatus === false) {
      history.push("/");
      return;
    }

    await DeviceAddressService.getInstance().getAllAddressAPICall();
    let zoneList = DeviceAddressService.getInstance().getZones(false);
    let wardList = [];//DeviceAddressService.getInstance().getWards(zoneList[0].value);
    setZoneFilterList(zoneList);
    setWardFilterList(wardList);
    console.log(`==> Zone list ${zoneList}\n\n WardList = ${wardList}`);
    // setFilterObj((prevState) => ({
    //   ...prevState,
    //   zone: zoneList[0].value,
    //   ward: wardList[0].value,
    // }));

    // setTimeout(() => {
    // getAllDevicesAPICall();
    //   getAllDeviceSummaryAPICall();
    // const treeZoneList = getZones();
    // const zoneList = treeZoneList.map((item) => ({
    //   label: item.value,
    //   value: item.id,
    //   // id: item.id
    // }));
    // console.log("getZones : ", zoneList);
    // setZoneFilterList(zoneList || []);
    // }, 3000);

    DeviceDataService.getInstance().initService(onFetchComplete, () => {

    }/*iterateDeviceHandler*/);

    var date = new Date();
    date.setDate(date.getDate() - 1);
    var date1 = new Date(date.getTime() - 300 * 60000);
    var date2 = new Date(date.getTime() - 291 * 60000);
    await getAllSLCDevices(0, 0, 0, false).then((data) => { setOpReportData(data); }).catch((e) => { });
    // [
    //   { dev_id: "SC1DGL10003", cr_dt: `${format(new Date().setDate(new Date().getDate() - 50), "dd/MM/yyyy")}`, ebox: "Yes", repair: `Repaired on ${format(new Date().setDate(new Date().getDate() - 3), "dd/MM/yyyy")}` },
    //   { dev_id: "SC1DGL10004", cr_dt: `${format(new Date().setDate(new Date().getDate() - 44), "dd/MM/yyyy")}`, ebox: "Yes", repair: `Repaired on ${format(new Date().setDate(new Date().getDate() - 8), "dd/MM/yyyy")}` },
    //   { dev_id: "SC1DGL10005", cr_dt: `${format(new Date().setDate(new Date().getDate() - 33), "dd/MM/yyyy")}`, ebox: "No", repair: `Repaired on ${format(new Date().setDate(new Date().getDate() - 13), "dd/MM/yyyy")}` },
    // ]
  }, []);

  async function onFetchComplete() {
    console.log(`========= EventReport : onFetchall SLC Device Complete()`);
  }

  async function updateDeviceFilterList(zoneId = 0, wardId = 0) {
    const { deviceList: deviceList = [] } = await DeviceDataService.getInstance().getDevicesByFilter(zoneId, wardId);
    setCcmsFilterList(deviceList);
  }

  // {dev_id:"SC1DGL10003",cr_dt:new Date().setDate(new Date().getDate() - 40), ebox:"Yes", repair:new Date().setDate(new Date().getDate() - 3)},
  // const getOpReportColumnList = () => {
  //   return [
  //     {
  //       title: 'UID',
  //       field: "dev_id",
  //       type: "datetime",
  //       exportTransformer: ({ displayData_date: displayData_date = 'N/A' }) => {
  //         return displayData_date.toLocaleString();
  //       },
  //     },
  //     {
  //       title: 'INSTALLED DATE',
  //       field: "cr_dt",
  //       sorting: false,
  //       // type: "numeric",
  //       // render:({displayData_eventType: displayData_eventType = 0}) => {
  //       //   return displayData_eventType;
  //       // },
  //       exportTransformer: ({ displayData_eventType: displayData_eventType = 0 }) => {
  //         return displayData_eventType;
  //       },
  //     },
  //     {
  //       title: 'EB METER',
  //       field: "ebox",
  //       exportTransformer: ({ displayData_date: displayData_date = 'N/A' }) => {
  //         return displayData_date.toLocaleString();
  //       },
  //     },
  //     {
  //       title: 'HISTORY',
  //       field: "repair",
  //       exportTransformer: ({ displayData_date: displayData_date = 'N/A' }) => {
  //         return displayData_date.toLocaleString();
  //       },
  //     },
  //     // {
  //     //   title: 'DATA',
  //     //   field: "displayData_status",
  //     //   sorting: false,
  //     //   width: "80%",
  //     //   // render:({displayData_status:displayData_status = ""}) => {
  //     //   //   return displayData_status;
  //     //   // },
  //     //   exportTransformer:({displayData_status:displayData_status = ""}) => {
  //     //     return displayData_status;
  //     //   },
  //     // }
  //   ];
  // };
  const getOpReportColumnList = () => {
    return [
      {
        title: 'UID',
        field: 'dev_id',
        cellStyle: {
          whiteSpace: 'nowrap'
        },
        searchable: true,
        render: ({ dev_id: ccmsNumber = "" }) => {
          return ccmsNumber;
        },
        exportTransformer: ({ dev_id: ccmsNumber = "" }) => {
          return ccmsNumber
        }
      },
      {
        title: 'Switch No.',
        field: 'sw_no',
        searchable: true,
        render: ({ sw_no: sw_no = "" }) => {
          return sw_no;
        },
        exportTransformer: ({ sw_no: sw_no = "" }) => {
          return sw_no
        }
      },
      {
        title: 'Phase.',
        field: "simNumber",
        render: ({ ph_cnt: ph_cnt = "" }) => {
          return ph_cnt;
        },
        exportTransformer: ({ ph_cnt: ph_cnt = "" }) => {
          return ph_cnt;
        }
      },
      {
        title: 'Ward.',
        field: "wd",
        render: ({ wd: wd = "" }) => {
          return wd;
        },
        exportTransformer: ({ wd: wd = "" }) => {
          return wd;
        }
      },
      {
        title: 'Zone.',
        field: "zn",
        render: ({ zn: zn = "" }) => {
          return zn;
        },
        exportTransformer: ({ zn: zn = "" }) => {
          return zn;
        }
      },
      {
        title: 'Address.',
        cellStyle: {
          minWidth: '250px',
        },
        render: (rowData) => {
          let pole = null;
          if (rowData.pid != undefined && rowData.pid != null) {
            pole = PoleDataService.getInstance().getPole(rowData.pid);
          }

          if (pole != null && pole.addr != undefined && pole.addr != null) {
            return pole.addr;
          } else if (rowData.addr != undefined | null | "") {
            return rowData.addr;
          }
          return "N/A"
        },
        exportTransformer: (rowData) => {
          let pole = null;
          if (rowData.pid != undefined && rowData.pid != null) {
            pole = PoleDataService.getInstance().getPole(rowData.pid);
          }

          if (pole != null && pole.addr != undefined && pole.addr != null) {
            return pole.addr;
          } else if (rowData.addr != undefined | null | "") {
            return rowData.addr;
          }
          return "N/A"
        }
      },
      {
        title: 'Total kW Before conversion.',
        field: "old_kw",
        render: ({ old_kw: old_kw = "" }) => {
          return old_kw;
        },
        exportTransformer: ({ old_kw: old_kw = "" }) => {
          return old_kw;
        }
      },
      {
        title: 'Number of Fixtures',
        field: "nfix",
        render: ({ nfix: nfix = "" }) => {
          return nfix;
        },
        exportTransformer: ({ nfix: nfix = "" }) => {
          return nfix;
        }
      },
      {
        title: 'Total Poles',
        field: "tpoles",
        render: ({ tpoles: tpoles = "" }) => {
          return tpoles;
        },
        exportTransformer: ({ tpoles: tpoles = "" }) => {
          return tpoles;
        }
      },
      {
        title: 'Service Conn.Number',
        field: "sc_no",
        render: ({ sc_no: sc_no = "" }) => {
          return sc_no;
        },
        exportTransformer: ({ sc_no: sc_no = "" }) => {
          return sc_no;
        }
      },
      {

        title: 'GPS Location',
        cellStyle: {
          whiteSpace: 'nowrap'
        },
        // field: "coords",
        render: (rowData) => {
          let degreeSymbol = "\u00B0";
          let result = "";
          let latitude = 0;
          let longitude = 0;
          let pole = null;
          if (rowData.pid != undefined && rowData.pid != null) {
            pole = PoleDataService.getInstance().getPole(rowData.pid);
          }

          if (pole != null && pole.loc != undefined && pole.loc != null) {
            const {
              loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
            } = pole;
            latitude = latitudeVal;
            longitude = longitudeVal;
          } else if (rowData.lloc != undefined | null) {
            const {
              lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
            } = rowData;
            latitude = latitudeVal;
            longitude = longitudeVal;
          } else {
            const {
              loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
            } = rowData;
            latitude = latitudeVal;
            longitude = longitudeVal;
          }


          if ((latitude === undefined | "") || (longitude === undefined | "")) {
            return "N/A"
          }
          if (latitude > 0) {
            result = `${latitude.toFixed(4)}${degreeSymbol}N`;
          } else {
            result = `${latitude.toFixed(4)}${degreeSymbol}S`;
          }
          if (longitude > 0) {
            result = `[${result}, ${longitude.toFixed(4)}${degreeSymbol}E]`;
          } else {
            result = `[${result}, ${longitude.toFixed(4)}${degreeSymbol}W]`;
          }
          return result;
        },
        exportTransformer: (rowData) => {
          let degreeSymbol = "\u00B0";
          let result = '';
          let latitude = 0;
          let longitude = 0;
          let pole = null;
          if (rowData.pid != undefined && rowData.pid != null) {
            pole = PoleDataService.getInstance().getPole(rowData.pid);
          }

          if (pole != null && pole.loc != undefined && pole.loc != null) {
            const {
              loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
            } = pole;
            latitude = latitudeVal;
            longitude = longitudeVal;
          } else if (rowData.lloc != undefined | null) {
            const {
              lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
            } = rowData;
            latitude = latitudeVal;
            longitude = longitudeVal;
          } else {
            const {
              loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
            } = rowData;
            latitude = latitudeVal;
            longitude = longitudeVal;
          }
          if ((latitude === undefined | "") || (longitude === undefined | "")) {
            return 'N/A'
          }
          if (latitude > 0) {
            result = `${latitude.toFixed(4)}${degreeSymbol}N`;
          } else {
            result = `${latitude.toFixed(4)}${degreeSymbol}S`;
          }
          if (longitude > 0) {
            result = `[${result}, ${longitude}${degreeSymbol}E]`;
          } else {
            result = `[${result}, ${longitude}${degreeSymbol}W]`;
          }
          return result;
        },
      },

      {
        title: 'SIM NO.',
        // field: "simNumber",
        render: ({ sim_no: simNumber = "" }) => {
          return simNumber;
        },
        exportTransformer: ({ sim_no: simNumber = "" }) => {
          return simNumber;
        }
      },
      {
        title: 'Pole ID',
        // field: "simNumber",
        cellStyle: {
          whiteSpace: 'nowrap'
        },
        render: ({ pid: pid = "" }) => {
          return pid;
        },
        exportTransformer: ({ pid: pid = "" }) => {
          return pid;
        }
      },
      {
        title: 'EB Box.',
        // field: "simNumber",
        render: ({ eb_box: eb_box = "" }) => {
          return eb_box;
        },
        exportTransformer: ({ eb_box: eb_box = "" }) => {
          return eb_box;
        }
      },

      {
        title: 'Create Date',
        // field: "date",
        type: "datetime",
        headerStyle: {
          whiteSpace: 'nowrap'
        },
        cellStyle: {
          whiteSpace: 'nowrap'
        },

        render: ({ cdt: cdt }) => {
          if (cdt != null && (typeof cdt) === 'object') {
            return format(cdt.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return "";
        },
        // exportTransformer:({ ls: {seconds:seconds = 1} = {seconds:seconds = 1} }) => {
        exportTransformer: ({ cdt: cdt }) => {
          if (cdt != null && (typeof cdt) === 'object') {
            return format(cdt.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return "";
        }
      },
      {
        title: 'Modified Date',
        // field: "date",
        type: "datetime",
        headerStyle: {
          whiteSpace: 'nowrap'
        },
        cellStyle: {
          whiteSpace: 'nowrap'
        },

        render: ({ mdt: mdt }) => {
          if (mdt != null && (typeof mdt) === 'object') {
            return format(mdt.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return "";
        },
        // exportTransformer:({ ls: {seconds:seconds = 1} = {seconds:seconds = 1} }) => {
        exportTransformer: ({ mdt: mdt }) => {
          if (mdt != null && (typeof mdt) === 'object') {
            return format(mdt.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return "";
        }
      },
    ];

  };


  const handleDateChange = (date, dateField) => {
    setFilterObj((prevState) => ({
      ...prevState,
      [dateField]: date,
    }));
  };

  const handleFilterChange = async (e) => {
    const { target: { name = "", value = "" } = {} } = e;
    console.log(`handleFilterChange -> ${name} = ${value}`);
    if (name === "zone") {
      let wardList = DeviceAddressService.getInstance().getWards(value, false);
      setWardFilterList(wardList);
      setFilterObj((prevState) => ({
        ...prevState,
        zone: value,
        ward: 0,
        ccms: 0,
      }));
    } else if (name === "ward") {
      const { zone: zone = 0 } = filterObj;
      await updateDeviceFilterList(zone, value);
      setFilterObj((prevState) => ({
        ...prevState,
        ward: value,
        ccms: 0,
      }));
    } else if (name === "filter-type") {
      setFilterObj((prevState) => ({
        ...prevState,
        filterType: value,
        ccms: 0,
      }));
    } else if (name === "ccms") {
      setFilterObj((prevState) => ({
        ...prevState,
        ccms: value,
      }));
    }
  };

  const handleFilterApply = async () => {
    const {
      startDate = new Date(),
      endDate = new Date(),
      filterType = 0,
      zone = 0,
      ward = 0,
      ccms = 0,
    } = filterObj;
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 0);
    if (startDate > endDate) {
      NotificationManager.error("Please select valid date", "", 3000);
      return;
    }
    const diffTime = Math.abs(endDate - startDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > 31) {
      NotificationManager.error("Please select date range less than or equal to 31 days", "", 5000);
      return;
    }
    if (zone == 0) {
      NotificationManager.error("Please select valid zone", "", 3000);
      return;
    }
    if (ward == 0) {
      NotificationManager.error("Please select valid ward", "", 3000);
      return;
    }
    // if (ccms == 0) {
    //   if (filterType == 0) {
    //     NotificationManager.error("Please select valid UID", "", 3000);
    //   } else {
    //     NotificationManager.error("Please select valid switch number", "", 3000);
    //   }
    //   return;
    // }
    // setIsAPILoading(true);
    // GetEventReportQuery(startDate,endDate,ccms).then((reportList) => {
    //   setOpReportData([...reportList]);
    //   setIsAPILoading(false);
    // }).catch((error) => {
    //   console.log('Energy Saving Report==> ', error.message);
    //   alert("Unable to complete your request. Please try after sometime.");
    // });
    // getAllDeviceSummaryAPICall();
    await getAllSLCDevices(0, ward, zone, false).then((data) => { setOpReportData(data); }).catch((e) => { });

  };

  const {
    startDate = new Date(),
    endDate = new Date(),
    filterType: filterType = 0,
    zone: zoneFilter = 0,
    ward: wardFilter = 0,
    ccms: ccmsFilter = 0,
  } = filterObj;

  return (
    <div className="reports">
      {/* {isAPILoading && (
        <Backdrop open={true} className={classes.backdrop}>
          <CircularProgress
            className="circular-progress-center"
            disableShrink
          />
        </Backdrop>
      )} */}
      <h2 className="reports-header">SLC Inventory</h2>
      {/* <Grid container className="reports-filter-wrapper">
        <Grid xs={12} sm={12}>
          <div className="reports-zw-filter">
      
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <InputLabel id="zone-label">Zone</InputLabel>
              <Select
                labelId="zone-label"
                id="zone-outlined"
                name="zone"
                value={zoneFilter}
                onChange={handleFilterChange}
                label="Zone"
              >
                {zoneFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <InputLabel id="ward-label">Ward</InputLabel>
              <Select
                labelId="ward-label"
                id="ward-outlined"
                name="ward"
                value={wardFilter}
                onChange={handleFilterChange}
                label="Ward"
              >
                {wardFilterList.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
           
            <Button
              variant="contained"
              onClick={async () => {
                await getAllSLCDevices(0, 0, 0, false).then((data) => { setFilterObj([]); setOpReportData(data); }).catch((e) => { });
              }}
            >
              Clear
            </Button>
            <Button
              variant="contained"
              className="ml-auto reports-apply-btn"
              onClick={handleFilterApply}
            >
              Apply
            </Button>
          </div>
        </Grid>
      </Grid> */}

      <div className="dashboard-table">
        <MaterialTable
          style={{
            margin: "20px 0",
            width: "100%",
          }}
          className={classes.table}
          title=""
          columns={getOpReportColumnList()}
          data={opReportData}
          onRowClick={(evt, rowData) => {
            console.log("row click", evt, rowData);
            // setSelectedRowData(rowData);
            // setIsErrorDialogOpen(true);
          }}
          options={{
            exportButton: true,
            exportAllData: true,
            exportCsv: (columns, csvData) => { exportMaterialTableToExcel(columns, csvData, `Energy Saving Report-${getDateString()}`); },
            exportPdf: (columns, csvData) => { exportMaterialTableToPDF(columns, csvData, `Energy Saving Report-${getDateString()}`, 8, 18); },
            // exportCsv: (columns, data) => ExportCsv(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`,","),
            // exportPdf: (columns, data) => ExportPdf(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`),
            // grouping: true,
            search: true,
            selection: false,
            sorting: true,
            pageSize: 10,
            // rowStyle: (rowData) => ({
            //   backgroundColor:
            //     rowData?.ccmsNumber === selectedRowData?.ccmsNumber
            //       ? "#f0f2f4"
            //       : "",
            // }),
            headerStyle: {
              backgroundColor: "#0071CE",
              color: "#FFF",
              fontSize: "0.9em",
              textAlign: "center",
            },
            actionsColumnIndex: -1,
            emptyRowsWhenPaging: false,
          }}
          localization={{
            toolbar: {
              searchPlaceholder: "Search",
              exportCSVName: "Export as Excel",
              exportPDFName: "Export as PDF",
            },
          }}
        />
      </div>
    </div>
  );
};
export default SLCInventory;
